import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { formConstant } from '../../../../../config';
import { PageParams } from '../../../../core/models/page-params.model';
import { IPaginatorProperties } from '../../../../core/models/paginator.interface';
import { UploadFileService } from '../../../../core/services/upload-file.service';
import { UserService } from '../../../../core/services/user.service';
import {
    ICarrierItem,
    IShipmentPriceItemData,
    IPriceListFilter,
    IService,
    ISubService,
    IVendor,
} from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../services/shipment-price.service';
import { PriceItemsDialogComponent } from './price-items-dialog/price-items-dialog.component';

@Component({
    selector: 'eci-shipment-price-items',
    templateUrl: './shipment-price-items.component.html',
    styleUrls: ['./shipment-price-items.component.scss'],
})
export class ShipmentPriceItemsComponent implements OnInit {

    public pageParams: PageParams = new PageParams();
    public currentSort: Sort;

    public vendors: IPaginatorProperties<IVendor> = {items: [], meta: undefined};
    public services: IPaginatorProperties<IService> = {items: [], meta: undefined};
    public carriers: IPaginatorProperties<ICarrierItem> = {items: [], meta: undefined};
    public subServices: IPaginatorProperties<ISubService> = {items: [], meta: undefined};

    public displayedColumns = ['priceID', 'vendors', 'services', 'subServices', 'carriers'];
    public displayedFields = ['vendors', 'services', 'subServices'];

    public showLoader: boolean = false;
    public dataSource: MatTableDataSource<IShipmentPriceItemData> = new MatTableDataSource<IShipmentPriceItemData>([]);
    public listOfSelectedItems: number[] = [];

    private searchValue: string;
    private filters: IPriceListFilter | {} = {};

    constructor(private userSvc: UserService,
                private dialog: MatDialog,
                private shipmentPriceSvc: ShipmentPriceService,
                public uploadFileSvc: UploadFileService,
    ) {
    }

    ngOnInit(): void {
        if (this.isAdmin) {
            this.displayedColumns.push(...['edit']);
        }
        this.pageParams.pageSize = formConstant.pageSize;
        this.pageParams.pageIndex = 0;

        this.getPrices();
        this.getParams<IVendor>('vendor', 'vendors', 'name', 'ASC');
        this.getParams<IService>('service', 'services', 'name', 'ASC');
        this.getParams<ISubService>('sub-service', 'subServices', 'name', 'ASC');
        this.getParams<ICarrierItem>('carriers', 'carriers', 'name', 'ASC');
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    private getPrices(
        page: number = this.pageParams.pageIndex,
        limit: number = this.pageParams.pageSize,
        q: string = this.searchValue || '',
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
    ): void {
        this.shipmentPriceSvc.get<IPaginatorProperties<IShipmentPriceItemData>>('shipment-price',
          page, limit, q, this.filters, orderField, orderDir)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.dataSource = new MatTableDataSource<IShipmentPriceItemData>(data.items);
                this.pageParams.pageSize = data?.meta?.itemsPerPage;
                this.pageParams.pageIndex = data?.meta?.currentPage - 1;
                this.pageParams.length = data?.meta?.totalItems;
            });
    }

    private getParams<T>(path: string, objectName: string,
                         orderField: string = 'createdAt',
                         orderDirection: string = 'DESC',
                         page: number = 1,
                         limit: number = 1000, q: string = ''): void {
        this.shipmentPriceSvc.get<IPaginatorProperties<T>>(path, page, limit, q, {select: 'dropdown'}, orderField, orderDirection)
          .subscribe((data) => {
              if (!data) {
                  return;
              }
              this[objectName].items = [...this[objectName].items, ...data.items];
              this[objectName].meta = data?.meta;
          });
    }

    public openDialog(shipmentPrice?: IShipmentPriceItemData): void {
        const dialogRef = this.dialog.open(PriceItemsDialogComponent,
            {
                maxHeight: '800px',
                width: '900px',
            },
        );
        dialogRef.componentInstance.createMode = !shipmentPrice;
        dialogRef.componentInstance.shipmentPrice = !shipmentPrice ? undefined : shipmentPrice;
        dialogRef.componentInstance.vendors = this.vendors.items;
        dialogRef.componentInstance.services = this.services.items;
        dialogRef.componentInstance.subServices = this.subServices.items;
        dialogRef.componentInstance.carriers = this.carriers.items;
        dialogRef.componentInstance.isFulfilment = (shipmentPrice?.shipmentService?.name.toUpperCase() === 'FULFILLMENT');
        dialogRef.componentInstance.title = !shipmentPrice ? 'Add Price List' : 'Edit Price List';
        dialogRef.afterClosed()
            .subscribe((result) => {
                this.getPrices();
            });
    }

    public onFilterUpdate(value: IPriceListFilter): void {
        this.searchValue = value.search;
        this.filters = value;
        this.getPrices();
    }

    public downloadExcel(filePathName: string, fileName: string): void {
        this.shipmentPriceSvc.downloadExcelExample(filePathName)
            .subscribe((data) => {
                this.uploadFileSvc.saveToFileSystem(data, fileName);
            });
    }

    public pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.getPrices(this.pageParams.pageIndex + 1);
    }

    public sortData(sort: Sort): void {
        this.currentSort = sort;
        this.getPrices();
    }

}
